import { useCallback } from "react";



const useRoomChange = ({
    rooms,
    roomTypeInfoByType,
    roomOfferByType,
    complementryByType,
    values,
    updateRoom,
    ensureTypeOptions,
    emptyRoom,
    setLoadingRooms, // (index, boolean) => void
}) => {

    const handleRoomChange = useCallback(
        async (index, name, value) => {
            let next = { ...rooms[index], [name]: value };



            // room_type_id changed
            if (name === "room_type_id") {
                next = { ...emptyRoom, room_type_id: value };

                setLoadingRooms?.(index, true);
                let fetched;
                try {
                    fetched = await ensureTypeOptions(value, next, index);
                    console.log(`Fetched room type info for index ${index}:`, fetched);
                } catch (error) {
                    console.error("Error fetching room type options:", error);
                    setLoadingRooms?.(index, false);
                } finally {
                    setLoadingRooms?.(index, false);
                }

                const details = fetched?.roomTypeInfo;
                const offerValue = fetched?.offerValue ?? 0;

                if (details) {
                    next = {
                        ...emptyRoom,
                        room_type_id: value,
                        room_rate: details.room_rate,
                        original_Rate: details.room_rate ?? 0,
                        extra_bed_charge: details.extra_bed_charge ?? 0,
                        extra_person_charge: details.extra_person_charge ?? 0,
                        extra_child_charge: details.extra_child_charge ?? 0,
                        extra_Capablity: details.exbed_capability ?? 0,
                        exbed_capability_limit: details.exbed_capability_limit ?? 0,
                        room_offer: offerValue,
                        capacity: details.capacity ?? 0,
                        room_rate: details.room_rate,
                        accommodation_type: details.accommodation_type || "",
                        avalible_beds: details.avalible_beds ?? 0,
                        rate_per_bed: details.rate_per_bed ?? 0,
                    };
                }

                updateRoom(index, next);
                return;
            }

            // room_id changed
            if (name === "room_id") {
                if (next.room_type_id) {
                    // setLoadingRooms?.(index, true);
                    try {
                        await ensureTypeOptions(next.room_type_id, next, index);
                    } finally {
                        setLoadingRooms?.(index, false);
                    }
                }
            }

            // complementary_id changed
            if (name === "complementary_id") {
                const roomKey = `${next.room_type_id}_${next.Unic_key}`;
                const list = complementryByType[roomKey] || [];
                const hit = list.find((c) => String(c.complementary_id) === String(value));

                next = {
                    ...next,
                    complementary_id: hit?.complementary_id ?? null,
                    complementary_name: hit?.complementary_name ?? "",
                    complementary_price: hit.complementary_price,
                    complementary_price_type: hit?.complementary_price_type ?? 0,
                };
            }

            const roomKey = `${next.room_type_id}_${next.Unic_key}`;
            const cachedInfo = roomTypeInfoByType[roomKey];

            if (
                next.room_type_id &&
                cachedInfo &&
                (
                    (next.extra_person_charge == null || Number(next.extra_person_charge) === 0) ||
                    (next.extra_bed_charge == null || Number(next.extra_bed_charge) === 0) ||
                    (next.extra_child_charge == null || Number(next.extra_child_charge) === 0)
                )
            ) {
                next = {
                    ...next,
                    extra_person_charge: Number(cachedInfo.extra_person_charge ?? 0),
                    extra_bed_charge: Number(cachedInfo.extra_bed_charge ?? 0),
                    extra_child_charge: Number(cachedInfo.extra_child_charge ?? 0),
                };
            }

            updateRoom(index, next);
        },
        [
            rooms,
            roomTypeInfoByType,
            roomOfferByType,
            complementryByType,
            values.checkin_date,
            values.checkout_date,
            updateRoom,
            ensureTypeOptions,
            emptyRoom,
            setLoadingRooms,
        ]
    );

    return { handleRoomChange };
};

export default useRoomChange;